import { autoinject, observable, bindable } from "aurelia-framework";
import {ReportService, IWordTemplateAM, IWordTemplateBaseAM} from './report-api';
import { GlobalContextService } from '../../components/global-select/global-context-service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { FileService } from "../../utils/file-service";
import { ResourcedNotificationService, NotificationType } from "../../components/notifications/notification-service";

@autoinject
export class ReportWordTemplate {
	@observable wordTemplates: IWordTemplateAM[];
	fileInputElement: HTMLInputElement;
	selectedFile: File | null;

	private showFileUpload: boolean = false;
	private customerId: string;

	constructor(private api: ReportService,
		private globalContext: GlobalContextService,
		private eventAggregator: EventAggregator,
		private files: FileService,
		private notificationService: ResourcedNotificationService) {
	}

	async attached() {
		this.customerId = this.globalContext.getId('customer');

		await this.fetchCustomerWordTemplates();
		this.resetFileSelection();

		this.eventAggregator.subscribe(`idChanged-customer`, async id => {
			this.customerId = id;
			this.resetFileSelection();
			await this.fetchCustomerWordTemplates();
		});
	}

	get isFileSelected() {
		return this.selectedFile == null;
	}
	
	private resetFileSelection() {
		if (this.fileInputElement) {
			this.fileInputElement.value = null;
		}
		
		this.selectedFile = null;
	}

	toggleFileUpload() {
		this.showFileUpload = !this.showFileUpload;
		this.resetFileSelection();
	}

	toggleFileSelector() {
		this.fileInputElement.click();
	}

	onFileSelected() {
		const fileList = this.fileInputElement.files;

		if (fileList.length == 0) {
			this.selectedFile = null;
		} else {
			this.selectedFile = fileList[0];
		}
	}

	async uploadFile() {
		const res = await this.files.upload<IWordTemplateBaseAM>(`reports/${this.customerId}/word-templates`, this.selectedFile, "post");
		if (res.id) {
			this.notificationService.push("Report_Notification_WordTemplateUploadSuccess", NotificationType.Success, null, [res.originalFileName]);
	
			await this.fetchCustomerWordTemplates();
			this.showFileUpload = false;
			this.resetFileSelection();
		}
	}

	async deleteWordTemplate(template: IWordTemplateAM) {
		const res = await this.api.deleteWordTemplate(this.customerId, template.id);
		if (res.id) {
			this.notificationService.push("Report_Notification_WordTemplateDeleteSuccess", NotificationType.Success);
			await this.fetchCustomerWordTemplates();
		}
	}

	async fetchCustomerWordTemplates() {
		if (this.customerId) {
			const res = await this.api.getCustomerWordTemplates(this.customerId);
			this.wordTemplates = res;
		}
	}
}
